import React from 'react'
import { motion } from 'framer-motion'


function Skill({skill, percent}) {
  return (
    <div className='group relative flex cursor-pointer'>
        <motion.img
        initial={{
            x: -200,
            opacity: 0
        }}
        transition={{ duration:1}}
        animate={{x:0, opacity:1}}
        whileInView={{ x:0, opacity:1 }}
        exit={{x:-200, opacity:0}}
        src={skill}
        className=' border border-gray-500 rounded-full object-cover w-12 h-12 md:w-16 md:h-16 xl:w-18 xl:h-18 filter group-hover:grayscale transition duration-100 ease-in-out'
        />
        <div className='absolute opacity-0 group-hover:opacity-60 transition-duration-300 ease-in-out md:w-16 md:h-16 group-hover:bg-white h-12 w-12 rounded-full z-0'>
            <div className='flex items-center justify-center h-full'>
                <div className='text-1xl xl:text-3xl font-bold text-black opacity-100'>{percent}</div>
            </div>
        </div>
    </div>
  )
}

export default Skill